// imports section Start
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import { BASEURL } from "../../config/Config";
import {
  removeGuestItemFromCart,
  increaseGuestItemQuantity,
  decreaseGuestItemQuantity,
  clearGuestCart,
} from "../../store/ReduxGuestCartReducer";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { GUEST_API_01 } from "../../api/ApiModel";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  MSG_CASHIER_FAILED,
  MSG_CASHIER_SUCCESS,
  MSG_EMPTY_CART,
} from "../../utils/sys/Messages";
import { encodeUrl, decodeUrl } from "../../utils/common/UrlUtils";
import { setUserParams } from "../../store/ReduxUser";
import {
  CON_STATUS_PENDING,
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
  CON_GUEST_REF_CODE,
  CON_ADDON_CODE,
  CON_STATUS_NONE,
  CON_IS_ADDON,
  CON_STATUS_RESTAURANTS,
  CON_VALUE_ZERO,
} from "../../utils/sys/Constants";
import { Navigate, useNavigate } from "react-router-dom";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import no_image from "../../assets/images/no_image.png";
import { IMAGEBASEURL } from "../../config/Config";

// imports section End

export default function GuestCheckout() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.guestCart.items);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // Hooks end

  const guestDecoded = useSelector((state) => state.guestDecoded);

  console.log("Guest Decoded Values:", guestDecoded);

  // Destructure `guestDecoded` with default fallback values
  const {
    COMPCODE = "",
    LOCCODE = "",
    RESTCODE = null,
    TABLECODE = null,
  } = guestDecoded || {};

  // Handlers start

  const handleRemoveItem = (id) => {
    dispatch(removeGuestItemFromCart(id));
  };

  const handleIncreaseQuantity = (id) => {
    dispatch(increaseGuestItemQuantity(id));
  };

  const handleDecreaseQuantity = (id) => {
    dispatch(decreaseGuestItemQuantity(id));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  // Handlers end

  // API calls start
  const handleGuestPlaceOrder = async () =>
    // COMPCODE,
    // loccode,
    // restcode,
    // tablecode

    {
      if (cartItems.length === 0) {
        setSnackbarMessage(MSG_EMPTY_CART);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        return;
      }

      const dayjs = require("dayjs");
      const formattedOrderDate = dayjs().format("YYYY-MM-DD");
      const formattedFromTime = dayjs()
        .hour(10)
        .minute(0)
        .second(0)
        .format("HH:mm:ss");
      const formattedToTime = dayjs()
        .hour(12)
        .minute(0)
        .second(0)
        .format("HH:mm:ss");

      // Construct payload
      const payload = {
        dtgDet: cartItems.map((item, index) => ({
          kotseqcode: index + 1,
          addoncode: CON_ADDON_CODE,
          menucatcode: String(item.MENUCATCODE),
          menucode: String(item.MENUCODE),
          qty: item.quantity,
          rate: item.ITEMRATE,
          amount: item.ITEMRATE,
          remark: String(item.REMARK),
          isaddon: CON_IS_ADDON, // Example value, modify as needed
          sts: CON_STATUS_PENDING, // Example value, modify as needed
        })),
        COMPCODE: COMPCODE,
        LOCCODE: LOCCODE,
        RESTCODE: RESTCODE,
        tablecode: TABLECODE===encodeUrl("null")? String(CON_VALUE_ZERO) : String(TABLECODE), 
        guestrefcode: CON_GUEST_REF_CODE, // Replace with actual value
        fromtime: formattedFromTime,
        totime: formattedToTime,
        remark: "Order from Guest Checkout",
        orderendate: formattedOrderDate,
        sts: CON_STATUS_PENDING,
        ressts: CON_STATUS_RESTAURANTS,
        enuser: CON_STATUS_NONE,
      };

      try {

        const response = await externalpostApi(GUEST_API_01, payload);
        console.log("order confirm", response);
        const orderCode = response;
        setSnackbarMessage("Order placed successfully!");
        setSnackbarOpen(true);
        dispatch(clearGuestCart());

        // dispatch(clearCashierCart());

        const encodedParams = new URLSearchParams({
          compcode: encodeUrl(COMPCODE),
          loccode: encodeUrl(LOCCODE),
          restcode: encodeUrl(RESTCODE),
          tablecode: encodeUrl(TABLECODE || ""),
        }).toString();

        navigate(`/Guest?${encodedParams}`, {
          state: {
            snackbarMessage: MSG_CASHIER_SUCCESS + " (Order Reference No. : " + response +")",
            snackbarSeverity: "success",
          },
        });
        setSnackbarMessage(MSG_CASHIER_SUCCESS);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } catch (error) {
        console.error("Error placing order:", error);
        setSnackbarMessage("Failed to place order.");
        setSnackbarOpen(true);
      }
    };
  // API calls end

  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: { xs: 6, sm: 8, md: 12 }, // Adjust top margin for different devices
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: { xs: "80vh", md: "80vh" }, // Full height for mobile, fixed for larger screens
          maxWidth: { xs: "100%", sm: 500 }, // Full width for mobile, max 500px for larger devices
          minWidth: { xs: "auto", sm: 500 }, // Remove fixed width on smaller devices
          border: `1px solid ${theme.palette.background.paper}`,
          boxShadow: 2,
          p: { xs: 2, md: 3 }, // Adjust padding
          position: "relative",
        }}
      >
        <Box container sx={styles.guest_cart_title}>
          <Typography variant="title">My Cart</Typography>
        </Box>
        <Grid
          container
          spacing={2}
          display={"flex"}
          justifyContent="center"
          alignContent={"flex-start"}
          sx={{
            overflow: "auto",
            maxHeight: "65vh",
            zIndex: 99,
            flexGrow: 1,
            px: { xs: 1, sm: 2 }, // Adjust padding for different devices
            pb: { xs: 1, sm: 2 },
          }}
        >
          {cartItems.length === 0 ? (
            <Box
              alignContent={"center"}
              justifyItems={"center"}
              sx={{ color: theme.palette.text.icons }}
            >
              <ShoppingCartRoundedIcon />
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  textAlign: "center",
                  mt: 4,
                }}
              >
                Add items from a restaurant or store to start a new cart.
              </Typography>
            </Box>
          ) : (
            cartItems.map((item) => (
              <Grid item xs={12} key={item.KOTSEQCODE}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "background.paper",
                    borderRadius: "8px",
                    boxShadow: 1,
                    p: { xs: 1, sm: 2 },
                  }}
                >
                  {/* Item Image */}
                  <CardMedia
                    component="img"
                    image={
                      item.WEBIMAGEPATH && item.WEBIMAGEPATH.trim() !== ""
                        ? `${IMAGEBASEURL}${item.WEBIMAGEPATH.replace("~", "")}`
                        : no_image
                    }
                    alt={item.MENUNAME}
                    sx={{
                      width: { xs: 60, sm: 80 }, // Smaller size for mobile
                      height: { xs: 60, sm: 80 },
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Item Details */}
                  <Box sx={{ flex: 1, ml: 2 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "0.875rem", sm: "1rem" }, // Adjust font size
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: { xs: "auto" }, // Adjust max-width for mobile
                      }}
                    >
                      {item.MENUNAME}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary", mt: 0.5 }}
                    >
                      {formatPrice(item.ITEMRATE)}
                    </Typography>

                    {/* Price and Remove Button */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        gap: 1,
                        justifyContent: "space-between",
                        mt: 1,
                      }}
                    >
                      {/* Quantity Controls */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          // flexDirection: "column",
                          gap: 1,
                          flexShrink: 0,
                        }}
                      >
                        <IconButton
                          aria-label="decrease quantity"
                          onClick={() =>
                            handleDecreaseQuantity(item.KOTSEQCODE)
                          }
                          size="small"
                          sx={{
                            backgroundColor: "action.hover",
                            "&:hover": { backgroundColor: "action.selected" },
                          }}
                        >
                          <RemoveIcon fontSize="small" />
                        </IconButton>
                        <Typography variant="body1" sx={{ mx: 1 }}>
                          {item.quantity}
                        </Typography>
                        <IconButton
                          aria-label="increase quantity"
                          onClick={() =>
                            handleIncreaseQuantity(item.KOTSEQCODE)
                          }
                          size="small"
                          sx={{
                            backgroundColor: "action.hover",
                            "&:hover": { backgroundColor: "action.selected" },
                          }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                      </Box>{" "}
                      <IconButton
                        aria-label="remove item"
                        onClick={() => handleRemoveItem(item.KOTSEQCODE)}
                        size="small"
                        sx={{
                          color: "error.main",
                          "&:hover": { color: "error.dark" },
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))
          )}
          {/* </Box> */}
        </Grid>{" "}
        <Box
          sx={{
            // position: "absolute",
            bottom: 16, // Spacing from the bottom
            left: 0,
            right: 0,
            // px: 3,
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleGuestPlaceOrder(COMPCODE, LOCCODE, RESTCODE)}
            sx={{ ...styles.btn_primary, width: "100%", Bottom: 0 }}
            // onClick={handleGuestPlaceOrder}
            // disabled={cartItems.length === 0}
          >
            Place Order
          </Button>
        </Box>
        <SnackbarMessage
          open={snackbarOpen}
          handleClose={handleCloseSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity} // Dynamic severity (success or error)
        />
      </Box>
    </Box>
  );
}
